import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Camera, Mic, Upload, FileText } from "lucide-react";

interface SubmissionTypeSelectorProps {
  onSelectType: (type: 'photo' | 'audio' | 'file' | 'text') => void;
}

const types = [
  {
    value: 'photo' as const,
    icon: Camera,
    label: 'Tirar Foto',
    description: 'Capture uma foto de exame ou documento',
    color: 'bg-blue-500 hover:bg-blue-600',
  },
  {
    value: 'audio' as const,
    icon: Mic,
    label: 'Gravar Áudio',
    description: 'Grave uma mensagem ou descrição',
    color: 'bg-purple-500 hover:bg-purple-600',
  },
  {
    value: 'file' as const,
    icon: Upload,
    label: 'Enviar Arquivo',
    description: 'Faça upload de PDF, imagem ou documento',
    color: 'bg-green-500 hover:bg-green-600',
  },
  {
    value: 'text' as const,
    icon: FileText,
    label: 'Escrever Texto',
    description: 'Digite suas informações diretamente',
    color: 'bg-orange-500 hover:bg-orange-600',
  },
];

export function SubmissionTypeSelector({ onSelectType }: SubmissionTypeSelectorProps) {
  return (
    <Card>
      <CardHeader className="text-center">
        <CardTitle className="text-2xl">Como deseja enviar seus dados?</CardTitle>
        <CardDescription>Escolha o formato mais conveniente para você</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {types.map((type) => {
            const Icon = type.icon;
            return (
              <button
                key={type.value}
                onClick={() => onSelectType(type.value)}
                className={`${type.color} text-white p-6 rounded-lg transition-all transform hover:scale-105 hover:shadow-lg`}
              >
                <div className="flex flex-col items-center text-center gap-3">
                  <Icon className="h-12 w-12" />
                  <div>
                    <h3 className="font-bold text-lg">{type.label}</h3>
                    <p className="text-sm opacity-90 mt-1">{type.description}</p>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
